import React, { useEffect, useState } from 'react';
import { MenuAcao, TipoExibicao } from '../MenuItemAcao';
import { Box, Tooltip } from '@mui/material';
import adminStore from 'src/store/AdminStore';

const ItemMenuEnviarNota: React.FC<MenuAcao> = (menuAcao) => {
    const handleClick = () => {
      if (menuAcao?.projetoId) {
        adminStore.buscarProjeto(menuAcao?.projetoId, true).then((resp) => {
          if (resp?.length && menuAcao?.handleOpenAcao) {
            menuAcao.handleOpenAcao(menuAcao);
          }
        });
      } else if (menuAcao && menuAcao.handleOpenAcao) {
        menuAcao?.handleOpenAcao(menuAcao);
      }
    };
    const [tipoExibicao, setTipoExibicao] = useState<TipoExibicao>(TipoExibicao.PADRAO);
    useEffect(() => {
        if (menuAcao && menuAcao?.exibicao) {
          setTipoExibicao(menuAcao.exibicao);
        }
      }, [menuAcao]);
  return (<Tooltip title="Disponível após envio para pagamento." placement='bottom' arrow>
    <Box>
        <div onClick={handleClick} className={tipoExibicao}>
            <div className='acao-titulo'>{menuAcao.titulo}</div>
        </div>
    </Box>
  </Tooltip>);
};

export default ItemMenuEnviarNota;
